
import { Component, OnInit } from '@angular/core';
import { MatDatepickerModule, MatInputModule, MatNativeDateModule } from '@angular/material';
import { getLocaleDateFormat, DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Timeline } from '../../../Models/AdminRights/timeline';
import { AdminRightsService } from '../../../Services/AdminRights/admin-rights.service';
import { parse } from 'querystring';
import * as moment from 'moment';
//import {CalendarModule} from 'primeng/primeng';

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.css'],
  providers: [DatePipe]
})
export class TimelineComponent implements OnInit {
  calModel1: any; calModel2: any; calModel3: any; calModel4: any;
  calModel5: any; calModel6: any; calModel7: any; calModel8: any;
  calModel9: any; calModel10: any; calModel11: any; calModel12: any;
  calModel13: any; calModel14: any; calModel15: any; calModel16: any; 
  calModel17: any; calModel18: any; calModel19: any; calModel20: any;
  calModel21: any; calModel22: any; calModel23: any; calModel24: any; 
  calModel25: any; calModel26: any; calModel27: any; calModel28: any; 
  calModel29: any; calModel30: any; calModel31: any; calModel32: any;
  calModel33: any; calModel34: any; calModel35: any; calModel36: any;  RequirmentYear: any;

  isBtnSubmitVisible: boolean;
  isBtnUpdateVisible: boolean;
  minDateValue = new Date();
  todayDate = new Date();
  minStartDate: Date;
  maxStartDate: Date;
  minEndDate: Date;
  maxEndDate: Date;
  FromStartDate: Date = new Date();
  ToEndDate: Date = new Date();
  CurrentYear: string;
  public timeline: Timeline[] = [];
  public userId: string;
  public roleId: number;
  public roleCode: string;
  hi: Date;

  //public _startDateAMM_ZMH_DMH_F1_u:string;
  public calId1Update: string;

  public tsResponse: Array<Timeline> = new Array<Timeline>();


  constructor(private toastr: ToastrService, private adminRight: AdminRightsService, private datePipe: DatePipe) {
    this.roleId = JSON.parse(localStorage.getItem('dsu_roleId'));
    this.roleCode = localStorage.getItem('dsu_roleCode');
    this.userId = localStorage.getItem('dsu_userId');
  }

  ngOnInit() {
    this.isBtnSubmitVisible = true;
    this.isBtnUpdateVisible = false;
    this.TimelineSettingView();
    this.CurrentYear = (new Date()).getFullYear().toString();
    // this.minStartDate = new Date(new Date().getFullYear(), 0, 1);
    // this.minEndDate = new Date(new Date().getFullYear(), 11, 31);
    // this.maxStartDate = new Date(new Date().getFullYear(), 0, 1);
    // this.maxEndDate = new Date(new Date().getFullYear(), 11, 31);
  }

  private IsDateValid(): boolean {

    let isValid: boolean = false;

    // if ((new Date(Object.prototype.toString.call(this.calModel2) === "[object String]" ? this.customeparse(this.calModel2) : this.calModel2)) <
    //   (new Date(Object.prototype.toString.call(this.calModel1) === "[object String]" ? this.customeparse(this.calModel1) : this.calModel1))) {
    //   this.toastr.error('Annual requirement submission [AMM/ZMH/DMH]From Date should be equal or greater than To Date.');
    //   isValid = false;
    // }

    if ((new Date(Object.prototype.toString.call(this.calModel18) === "[object String]" ? this.customeparse(this.calModel18) : this.calModel18)) <
      (new Date(Object.prototype.toString.call(this.calModel17) === "[object String]" ? this.customeparse(this.calModel17) : this.calModel17))) {
      this.toastr.error('H1 requirement submission [AMM/ZMH/DMH]From Date should be equal or greater than To Date.');
      isValid = false;
    }

    else if ((new Date(Object.prototype.toString.call(this.calModel20) === "[object String]" ? this.customeparse(this.calModel20) : this.calModel20)) <
      (new Date(Object.prototype.toString.call(this.calModel19) === "[object String]" ? this.customeparse(this.calModel19) : this.calModel19))) {
      this.toastr.error('H2 requirement submission [AMM/ZMH/DMH]From Date should be equal or greater than To Date.');
      isValid = false;
    }

    else if ((new Date(Object.prototype.toString.call(this.calModel22) === "[object String]" ? this.customeparse(this.calModel22) : this.calModel22)) <
      (new Date(Object.prototype.toString.call(this.calModel21) === "[object String]" ? this.customeparse(this.calModel21) : this.calModel21))) {
      this.toastr.error('H1 Approval on requirement[ZMH] From Date should be equal or greater than To Date.');
      isValid = false;
    }

    else if ((new Date(Object.prototype.toString.call(this.calModel24) === "[object String]" ? this.customeparse(this.calModel24) : this.calModel24)) <
      (new Date(Object.prototype.toString.call(this.calModel23) === "[object String]" ? this.customeparse(this.calModel23) : this.calModel23))) {
      this.toastr.error('H1 Approval on requirement[DMH] From Date should be equal or greater than To Date.');
      isValid = false;
    }

    else if ((new Date(Object.prototype.toString.call(this.calModel26) === "[object String]" ? this.customeparse(this.calModel26) : this.calModel26)) <
      (new Date(Object.prototype.toString.call(this.calModel25) === "[object String]" ? this.customeparse(this.calModel25) : this.calModel25))) {
      this.toastr.error('H1 Approval on requirement[FMGM] From Date should be equal or greater than To Date.');
      isValid = false;
    }

    else if ((new Date(Object.prototype.toString.call(this.calModel28) === "[object String]" ? this.customeparse(this.calModel28) : this.calModel28)) <
      (new Date(Object.prototype.toString.call(this.calModel27) === "[object String]" ? this.customeparse(this.calModel27) : this.calModel27))) {
      this.toastr.error('H2 Approval on requirement[ZMH] From Date should be equal or greater than To Date.');
      isValid = false;
    }

    else if ((new Date(Object.prototype.toString.call(this.calModel30) === "[object String]" ? this.customeparse(this.calModel30) : this.calModel30)) <
      (new Date(Object.prototype.toString.call(this.calModel29) === "[object String]" ? this.customeparse(this.calModel29) : this.calModel29))) {
      this.toastr.error('H2 Approval on requirement[DMH] From Date should be equal or greater than To Date.');
      isValid = false;
    }

    else if ((new Date(Object.prototype.toString.call(this.calModel32) === "[object String]" ? this.customeparse(this.calModel32) : this.calModel32)) <
      (new Date(Object.prototype.toString.call(this.calModel31) === "[object String]" ? this.customeparse(this.calModel31) : this.calModel31))) {
      this.toastr.error('H2 Approval on requirement[FMGM] From Date should be equal or greater than To Date.');
      isValid = false;
    }

    else if ((new Date(Object.prototype.toString.call(this.calModel34) === "[object String]" ? this.customeparse(this.calModel34) : this.calModel34)) <
      (new Date(Object.prototype.toString.call(this.calModel33) === "[object String]" ? this.customeparse(this.calModel33) : this.calModel33))) {
      this.toastr.error('H1 DS cost approval[BM] From Date should be equal or greater than To Date.');
      isValid = false;
    }

    else if ((new Date(Object.prototype.toString.call(this.calModel36) === "[object String]" ? this.customeparse(this.calModel36) : this.calModel36)) <
      (new Date(Object.prototype.toString.call(this.calModel35) === "[object String]" ? this.customeparse(this.calModel35) : this.calModel35))) {
      this.toastr.error('H2 DS cost approval[BM] From Date should be equal or greater than To Date.');
      isValid = false;
    }
    // else if ((new Date(Object.prototype.toString.call(this.calModel4) === "[object String]" ? this.customeparse(this.calModel4) : this.calModel4)) <
    //   (new Date(Object.prototype.toString.call(this.calModel3) === "[object String]" ? this.customeparse(this.calModel3) : this.calModel3))) {
    //   this.toastr.error('Approval on requirement[ZMH] From Date should be equal or greater than To Date.');
    //   isValid = false;
    // }

    // else if ((new Date(Object.prototype.toString.call(this.calModel6) === "[object String]" ? this.customeparse(this.calModel6) : this.calModel6)) <
    //   (new Date(Object.prototype.toString.call(this.calModel5) === "[object String]" ? this.customeparse(this.calModel5) : this.calModel5))) {
    //   this.toastr.error('Approval on requirement[DMH] From Date should be equal or greater than To Date.');
    //   isValid = false;
    // }

    else if ((new Date(Object.prototype.toString.call(this.calModel8) === "[object String]" ? this.customeparse(this.calModel8) : this.calModel8)) <
      (new Date(Object.prototype.toString.call(this.calModel7) === "[object String]" ? this.customeparse(this.calModel7) : this.calModel7))) {
      this.toastr.error('Demo sample allocation[AMM/ZMH/DMH] From Date should be equal or greater than To Date.');
      isValid = false;
    }

    else if ((new Date(Object.prototype.toString.call(this.calModel10) === "[object String]" ? this.customeparse(this.calModel10) : this.calModel10)) <
      (new Date(Object.prototype.toString.call(this.calModel9) === "[object String]" ? this.customeparse(this.calModel9) : this.calModel9))) {
      this.toastr.error('Demo sample allocation[BM] From Date should be equal or greater than To Date.');
      isValid = false;
    }
    else if ((new Date(Object.prototype.toString.call(this.calModel12) === "[object String]" ? this.customeparse(this.calModel12) : this.calModel12)) <
      (new Date(Object.prototype.toString.call(this.calModel11) === "[object String]" ? this.customeparse(this.calModel11) : this.calModel11))) {
      this.toastr.error('Demo sample allocation[SDHO]From Date should be equal or greater than To Date.');
      isValid = false;
    }
    else if ((new Date(Object.prototype.toString.call(this.calModel14) === "[object String]" ? this.customeparse(this.calModel14) : this.calModel14)) <
      (new Date(Object.prototype.toString.call(this.calModel13) === "[object String]" ? this.customeparse(this.calModel13) : this.calModel13))) {
      this.toastr.error('Demo sample allocation [SDWH] From Date should be equal or greater than To Date.');
      isValid = false;
    }
    else if ((new Date(Object.prototype.toString.call(this.calModel16) === "[object String]" ? this.customeparse(this.calModel16) : this.calModel16)) <
      (new Date(Object.prototype.toString.call(this.calModel15) === "[object String]" ? this.customeparse(this.calModel15) : this.calModel15))) {
      this.toastr.error('Demo sample allocation [FMGM]From Date should be equal or greater than To Date.');
      isValid = false;
    }
  //   else if ((new Date(Object.prototype.toString.call(this.calModel3) === "[object String]" ? this.customeparse(this.calModel3) : this.calModel3)) <
  //     (new Date(Object.prototype.toString.call(this.calModel1) === "[object String]" ? this.customeparse(this.calModel1) : this.calModel1))) {
  //     this.toastr.error('Approval on requirement[ZMH] From Date should be equal or greater than annual requirement submission from Date.');
  //     isValid = false;
  //   }
  //   else if ((new Date(Object.prototype.toString.call(this.calModel5) === "[object String]" ? this.customeparse(this.calModel5) : this.calModel5)) <
  //   (new Date(Object.prototype.toString.call(this.calModel1) === "[object String]" ? this.customeparse(this.calModel1) : this.calModel1))) {
  //   this.toastr.error('Approval on requirement[DMH] From Date should be equal or greater than annual requirement submission from Date.');
  //   isValid = false;
  // }
  else if ((new Date(Object.prototype.toString.call(this.calModel15) === "[object String]" ? this.customeparse(this.calModel15) : this.calModel15)) <
  (new Date(Object.prototype.toString.call(this.calModel1) === "[object String]" ? this.customeparse(this.calModel1) : this.calModel1))) {
  this.toastr.error('Approval on requirement[FMGM] From Date should be equal or greater than annual requirement submission from Date.');
  isValid = false;
}
    else {
      isValid = true;
    }
    return isValid;
  }

  customeparse(value: any): Date | null {

    if ((typeof value === 'string') && (value.includes('/'))) {
      const str = value.split('/');

      const year = Number(str[2]);
      const month = Number(str[1]) - 1;
      const date = Number(str[0]);

      return new Date(year, month, date);
    } else if ((typeof value === 'string') && value === '') {
      return new Date();
    }
    const timestamp = typeof value === 'number' ? value : Date.parse(value);
    return isNaN(timestamp) ? null : new Date(timestamp);
  }

  private IsUserAdmin(roleCode: string): boolean {
    if (roleCode == "ADM") {
      return true;
    }
    else {
      return false;
    }
  }

  getRequirementMaxYear()
  {
     return new Date().getFullYear()+1;
  }

  // private TimelineSubmit(): void {
  //   const _startDateAMM_ZMH_DMH_F1 = new Date(this.calModel1).toLocaleDateString("en-US");
  //   const _endDateAMM_ZMH_DMH_F1 = new Date(this.calModel2).toLocaleDateString("en-US");

  //   const _startDateZMH_F3 = new Date(this.calModel3).toLocaleDateString("en-US");
  //   const _endDateZMH_F3 = new Date(this.calModel4).toLocaleDateString("en-US");

  //   const _startDateDMH_F3 = new Date(this.calModel5).toLocaleDateString("en-US");
  //   const _endDateDMH_F3 = new Date(this.calModel6).toLocaleDateString("en-US");

  //   const _startDateAMM_ZMH_DMH_F5 = new Date(this.calModel7).toLocaleDateString("en-US");
  //   const _endDateAMM_ZMH_DMH_F5 = new Date(this.calModel8).toLocaleDateString("en-US");

  //   const _todayDate = new Date(this.todayDate).toLocaleDateString("en-US");

  //   if (this.IsUserAdmin(this.roleCode)) {
  //     if (this.IsDateValid()) {
  //       this.timeline = [];
  //       const _requestAMM_F1 = {
  //         formId: 1,
  //         startDate: _startDateAMM_ZMH_DMH_F1,
  //         endDate: _endDateAMM_ZMH_DMH_F1,
  //         roleCode: "AMM",
  //         roleId:42,
  //         createdBy: this.userId,
  //         createdOn: _todayDate,
  //         isActive: true,
  //         modifiedBy: this.userId,
  //         modifiedOn: _todayDate,

  //       }
  //       const _requestZMH_F1 = {
  //         formId: 1,
  //         startDate: _startDateAMM_ZMH_DMH_F1,
  //         endDate: _endDateAMM_ZMH_DMH_F1,
  //         roleCode: "ZMH",
  //         roleId: 43,
  //         createdBy: this.userId,
  //         createdOn: _todayDate,
  //         isActive: true,
  //         modifiedBy: this.userId,
  //         modifiedOn: _todayDate,

  //       }
  //       const _requestDMH_F1 = {
  //         formId: 1,
  //         startDate: _startDateAMM_ZMH_DMH_F1,
  //         endDate: _endDateAMM_ZMH_DMH_F1,
  //         roleCode: "DMH",
  //         roleId: 39,
  //         createdBy: this.userId,
  //         createdOn: _todayDate,
  //         isActive: true,
  //         modifiedBy: this.userId,
  //         modifiedOn: _todayDate,

  //       }
  //       const _requestZMH_F3 = {
  //         formId: 3,
  //         startDate: _startDateZMH_F3,
  //         endDate: _endDateZMH_F3,
  //         roleCode: "ZMH",
  //         roleId: 43,
  //         createdBy: this.userId,
  //         createdOn: _todayDate,
  //         isActive: true,
  //         modifiedBy: this.userId,
  //         modifiedOn: _todayDate,

  //       }
  //       const _requestDMH_F3 = {
  //         formId: 3,
  //         startDate: _startDateDMH_F3,
  //         endDate: _endDateDMH_F3,
  //         roleCode: "DMH",
  //         roleId: 39,
  //         createdBy: this.userId,
  //         createdOn: _todayDate,
  //         isActive: true,
  //         modifiedBy: this.userId,
  //         modifiedOn: _todayDate,

  //       }
  //       const _requestAMM_F5 = {
  //         formId: 5,
  //         startDate: _startDateAMM_ZMH_DMH_F5,
  //         endDate: _endDateAMM_ZMH_DMH_F5,
  //         roleCode: "AMM",
  //         roleId:42,
  //         createdBy: this.userId,
  //         createdOn: _todayDate,
  //         isActive: true,
  //         modifiedBy: this.userId,
  //         modifiedOn: _todayDate,

  //       }
  //       const _requestZMH_F5 = {
  //         formId: 5,
  //         startDate: _startDateAMM_ZMH_DMH_F5,
  //         endDate: _endDateAMM_ZMH_DMH_F5,
  //         roleCode: "ZMH",
  //         roleId: 43,
  //         createdBy: this.userId,
  //         createdOn: _todayDate,
  //         isActive: true,
  //         modifiedBy: this.userId,
  //         modifiedOn: _todayDate,

  //       }
  //       const _requestDMH_F5 = {
  //         formId: 5,
  //         startDate: _startDateAMM_ZMH_DMH_F5,
  //         endDate: _endDateAMM_ZMH_DMH_F5,
  //         roleCode: "DMH",
  //         roleId: 39,
  //         createdBy: this.userId,
  //         createdOn: _todayDate,
  //         isActive: true,
  //         modifiedBy: this.userId,
  //         modifiedOn: _todayDate,

  //       }
  //       this.timeline.push(_requestAMM_F1);
  //       this.timeline.push(_requestZMH_F1);
  //       this.timeline.push(_requestDMH_F1);
  //       this.timeline.push(_requestZMH_F3);
  //       this.timeline.push(_requestDMH_F3);
  //       this.timeline.push(_requestAMM_F5);
  //       this.timeline.push(_requestZMH_F5);
  //       this.timeline.push(_requestDMH_F5);
  //       this.adminRight.TimelineSettingSave(this.timeline).subscribe((resData: any) => {
  //         if (resData.status) {
  //           this.toastr.success('Admin timeline saved');
  //         }
  //         else {
  //           this.toastr.error('Admin timeline saved failed');
  //         }
  //       })
  //     }
  //   }
  //   else {
  //     this.toastr.error('Only admin is authorized for timeline settings');
  //   }
  // }

  TimelineUpdate(): void {
    this.timeline = [];
    const _todayDate = new Date(this.todayDate).toLocaleDateString("en-US");
    if (this.IsUserAdmin(this.roleCode)) {
      if (this.IsDateValid()) {
        //const _date = new Date(this.calModel1).toLocaleDateString("en-IN") == 'Invalid Date' ? new Date(this.calModel1).toLocaleDateString("en-IN") : this.calModel1
        // const _requestAMM_F1 = {
        //   formId: 1,
        //   startDate: typeof this.calModel1 === 'string' ? this.calModel1 : this.datePipe.transform(this.calModel1, 'dd/MM/yyyy'),
        //   endDate: typeof this.calModel2 === 'string' ? this.calModel2 : this.datePipe.transform(this.calModel2, 'dd/MM/yyyy'),
        //   roleCode: "AMM",
        //   roleId: 42,
        //   createdBy: this.userId,
        //   createdOn: null,
        //   isActive: true,
        //   modifiedBy: this.userId,
        //   modifiedOn: _todayDate,
        //   requirementYear : this.RequirmentYear,


        // }
        // const _requestZMH_F1 = {
        //   formId: 1,
        //   startDate: typeof this.calModel1 === 'string' ? this.calModel1 : this.datePipe.transform(this.calModel1, 'dd/MM/yyyy'),
        //   endDate: typeof this.calModel2 === 'string' ? this.calModel2 : this.datePipe.transform(this.calModel2, 'dd/MM/yyyy'),
        //   roleCode: "ZMH",
        //   roleId: 43,
        //   createdBy: this.userId,
        //   createdOn: null,
        //   isActive: true,
        //   modifiedBy: this.userId,
        //   modifiedOn: _todayDate,
        //   requirementYear : this.RequirmentYear,


        // }
        // const _requestDMH_F1 = {
        //   formId: 1,
        //   startDate: typeof this.calModel1 === 'string' ? this.calModel1 : this.datePipe.transform(this.calModel1, 'dd/MM/yyyy'),
        //   endDate: typeof this.calModel2 === 'string' ? this.calModel2 : this.datePipe.transform(this.calModel2, 'dd/MM/yyyy'),
        //   roleCode: "DMH",
        //   roleId: 39,
        //   createdBy: this.userId,
        //   createdOn: null,
        //   isActive: true,
        //   modifiedBy: this.userId,
        //   modifiedOn: _todayDate,
        //   requirementYear : this.RequirmentYear,


        // }
        const _requestAMM_F9 = {
          formId: 9,
          startDate: typeof this.calModel17 === 'string' ? this.calModel17 : this.datePipe.transform(this.calModel17, 'dd/MM/yyyy'),
          endDate: typeof this.calModel18 === 'string' ? this.calModel18 : this.datePipe.transform(this.calModel18, 'dd/MM/yyyy'),
          roleCode: "AMM",
          roleId: 42,
          createdBy: this.userId,
          createdOn: null,
          isActive: true,
          modifiedBy: this.userId,
          modifiedOn: _todayDate,
          requirementYear : this.RequirmentYear,


        }
        const _requestZMH_F9 = {
          formId: 9,
          startDate: typeof this.calModel17 === 'string' ? this.calModel17 : this.datePipe.transform(this.calModel17, 'dd/MM/yyyy'),
          endDate: typeof this.calModel18 === 'string' ? this.calModel18 : this.datePipe.transform(this.calModel18, 'dd/MM/yyyy'),
          roleCode: "ZMH",
          roleId: 43,
          createdBy: this.userId,
          createdOn: null,
          isActive: true,
          modifiedBy: this.userId,
          modifiedOn: _todayDate,
          requirementYear : this.RequirmentYear,


        }
        const _requestDMH_F9 = {
          formId: 9,
          startDate: typeof this.calModel17 === 'string' ? this.calModel17 : this.datePipe.transform(this.calModel17, 'dd/MM/yyyy'),
          endDate: typeof this.calModel18 === 'string' ? this.calModel18 : this.datePipe.transform(this.calModel18, 'dd/MM/yyyy'),
          roleCode: "DMH",
          roleId: 39,
          createdBy: this.userId,
          createdOn: null,
          isActive: true,
          modifiedBy: this.userId,
          modifiedOn: _todayDate,
          requirementYear : this.RequirmentYear,


        }
        const _requestAMM_F10 = {
          formId: 10,
          startDate: typeof this.calModel19 === 'string' ? this.calModel19 : this.datePipe.transform(this.calModel19, 'dd/MM/yyyy'),
          endDate: typeof this.calModel20 === 'string' ? this.calModel20 : this.datePipe.transform(this.calModel20, 'dd/MM/yyyy'),
          roleCode: "AMM",
          roleId: 42,
          createdBy: this.userId,
          createdOn: null,
          isActive: true,
          modifiedBy: this.userId,
          modifiedOn: _todayDate,
          requirementYear : this.RequirmentYear,


        }
        const _requestZMH_F10 = {
          formId: 10,
          startDate: typeof this.calModel19 === 'string' ? this.calModel19 : this.datePipe.transform(this.calModel19, 'dd/MM/yyyy'),
          endDate: typeof this.calModel20 === 'string' ? this.calModel20 : this.datePipe.transform(this.calModel20, 'dd/MM/yyyy'),
          roleCode: "ZMH",
          roleId: 43,
          createdBy: this.userId,
          createdOn: null,
          isActive: true,
          modifiedBy: this.userId,
          modifiedOn: _todayDate,
          requirementYear : this.RequirmentYear,


        }
        const _requestDMH_F10 = {
          formId: 10,
          startDate: typeof this.calModel19 === 'string' ? this.calModel19 : this.datePipe.transform(this.calModel19, 'dd/MM/yyyy'),
          endDate: typeof this.calModel20 === 'string' ? this.calModel20 : this.datePipe.transform(this.calModel20, 'dd/MM/yyyy'),
          roleCode: "DMH",
          roleId: 39,
          createdBy: this.userId,
          createdOn: null,
          isActive: true,
          modifiedBy: this.userId,
          modifiedOn: _todayDate,
          requirementYear : this.RequirmentYear,


        }
        // const _requestZMH_F3 = {
        //   formId: 3,
        //   startDate: typeof this.calModel3 === 'string' ? this.calModel3 : this.datePipe.transform(this.calModel3, 'dd/MM/yyyy'),
        //   endDate: typeof this.calModel4 === 'string' ? this.calModel4 : this.datePipe.transform(this.calModel4, 'dd/MM/yyyy'),
        //   roleCode: "ZMH",
        //   roleId: 43,
        //   createdBy: this.userId,
        //   createdOn: null,
        //   isActive: true,
        //   modifiedBy: this.userId,
        //   modifiedOn: _todayDate,
        //   requirementYear : this.RequirmentYear,


        // }
        // const _requestDMH_F3 = {
        //   formId: 3,
        //   startDate: typeof this.calModel5 === 'string' ? this.calModel5 : this.datePipe.transform(this.calModel5, 'dd/MM/yyyy'),
        //   endDate: typeof this.calModel6 === 'string' ? this.calModel6 : this.datePipe.transform(this.calModel6, 'dd/MM/yyyy'),
        //   roleCode: "DMH",
        //   roleId: 39,
        //   createdBy: this.userId,
        //   createdOn: null,
        //   isActive: true,
        //   modifiedBy: this.userId,
        //   modifiedOn: _todayDate,
        //   requirementYear : this.RequirmentYear,


        // }
        const _requestZMH_F11 = {
          formId: 11,
          startDate: typeof this.calModel21 === 'string' ? this.calModel21 : this.datePipe.transform(this.calModel21, 'dd/MM/yyyy'),
          endDate: typeof this.calModel22 === 'string' ? this.calModel22 : this.datePipe.transform(this.calModel22, 'dd/MM/yyyy'),
          roleCode: "ZMH",
          roleId: 43,
          createdBy: this.userId,
          createdOn: null,
          isActive: true,
          modifiedBy: this.userId,
          modifiedOn: _todayDate,
          requirementYear : this.RequirmentYear,


        }
        const _requestDMH_F11 = {
          formId: 11,
          startDate: typeof this.calModel23 === 'string' ? this.calModel23 : this.datePipe.transform(this.calModel23, 'dd/MM/yyyy'),
          endDate: typeof this.calModel24 === 'string' ? this.calModel24 : this.datePipe.transform(this.calModel24, 'dd/MM/yyyy'),
          roleCode: "DMH",
          roleId: 39,
          createdBy: this.userId,
          createdOn: null,
          isActive: true,
          modifiedBy: this.userId,
          modifiedOn: _todayDate,
          requirementYear : this.RequirmentYear,


        }
        const _requestSBUMH_F11 = {
          formId: 11,
          startDate: typeof this.calModel25 === 'string' ? this.calModel25 : this.datePipe.transform(this.calModel25, 'dd/MM/yyyy'),
          endDate: typeof this.calModel26 === 'string' ? this.calModel26 : this.datePipe.transform(this.calModel26, 'dd/MM/yyyy'),
          roleCode: "FMGM",
          roleId: 36,
          createdBy: this.userId,
          createdOn: null,
          isActive: true,
          modifiedBy: this.userId,
          modifiedOn: _todayDate,
          requirementYear : this.RequirmentYear,


        }

        const _requestZMH_F12 = {
          formId: 12,
          startDate: typeof this.calModel27 === 'string' ? this.calModel27 : this.datePipe.transform(this.calModel27, 'dd/MM/yyyy'),
          endDate: typeof this.calModel28 === 'string' ? this.calModel28 : this.datePipe.transform(this.calModel28, 'dd/MM/yyyy'),
          roleCode: "ZMH",
          roleId: 43,
          createdBy: this.userId,
          createdOn: null,
          isActive: true,
          modifiedBy: this.userId,
          modifiedOn: _todayDate,
          requirementYear : this.RequirmentYear,


        }
        const _requestDMH_F12 = {
          formId: 12,
          startDate: typeof this.calModel29 === 'string' ? this.calModel29 : this.datePipe.transform(this.calModel29, 'dd/MM/yyyy'),
          endDate: typeof this.calModel30 === 'string' ? this.calModel30 : this.datePipe.transform(this.calModel30, 'dd/MM/yyyy'),
          roleCode: "DMH",
          roleId: 39,
          createdBy: this.userId,
          createdOn: null,
          isActive: true,
          modifiedBy: this.userId,
          modifiedOn: _todayDate,
          requirementYear : this.RequirmentYear,


        }
        const _requestSBUMH_F12 = {
          formId: 12,
          startDate: typeof this.calModel31 === 'string' ? this.calModel31 : this.datePipe.transform(this.calModel31, 'dd/MM/yyyy'),
          endDate: typeof this.calModel32 === 'string' ? this.calModel32 : this.datePipe.transform(this.calModel32, 'dd/MM/yyyy'),
          roleCode: "FMGM",
          roleId: 36,
          createdBy: this.userId,
          createdOn: null,
          isActive: true,
          modifiedBy: this.userId,
          modifiedOn: _todayDate,
          requirementYear : this.RequirmentYear,


        }
        
        const _requestAMM_F5 = {
          formId: 5,
          startDate: typeof this.calModel7 === 'string' ? this.calModel7 : this.datePipe.transform(this.calModel7, 'dd/MM/yyyy'),
          endDate: typeof this.calModel8 === 'string' ? this.calModel8 : this.datePipe.transform(this.calModel8, 'dd/MM/yyyy'),
          roleCode: "AMM",
          roleId: 42,
          createdBy: this.userId,
          createdOn: null,
          isActive: true,
          modifiedBy: this.userId,
          modifiedOn: _todayDate,
          requirementYear : this.RequirmentYear,


        }
        const _requestZMH_F5 = {
          formId: 5,
          startDate: typeof this.calModel7 === 'string' ? this.calModel7 : this.datePipe.transform(this.calModel7, 'dd/MM/yyyy'),
          endDate: typeof this.calModel8 === 'string' ? this.calModel8 : this.datePipe.transform(this.calModel8, 'dd/MM/yyyy'),
          roleCode: "ZMH",
          roleId: 43,
          createdBy: this.userId,
          createdOn: null,
          isActive: true,
          modifiedBy: this.userId,
          modifiedOn: _todayDate,
          requirementYear : this.RequirmentYear,


        }
        const _requestDMH_F5 = {
          formId: 5,
          startDate: typeof this.calModel7 === 'string' ? this.calModel7 : this.datePipe.transform(this.calModel7, 'dd/MM/yyyy'),
          endDate: typeof this.calModel8 === 'string' ? this.calModel8 : this.datePipe.transform(this.calModel8, 'dd/MM/yyyy'),
          roleCode: "DMH",
          roleId: 39,
          createdBy: this.userId,
          createdOn: null,
          isActive: true,
          modifiedBy: this.userId,
          modifiedOn: _todayDate,
          requirementYear : this.RequirmentYear,


        }
        // const _requestSBUMH_F3 = {
        //   formId: 3,
        //   startDate: typeof this.calModel15 === 'string' ? this.calModel15 : this.datePipe.transform(this.calModel15, 'dd/MM/yyyy'),
        //   endDate: typeof this.calModel16 === 'string' ? this.calModel16 : this.datePipe.transform(this.calModel16, 'dd/MM/yyyy'),
        //   roleCode: "FMGM",
        //   roleId: 36,
        //   createdBy: this.userId,
        //   createdOn: null,
        //   isActive: true,
        //   modifiedBy: this.userId,
        //   modifiedOn: _todayDate,
        //   requirementYear : this.RequirmentYear,


        // }
        // const _requestMKTG_F4 = {
        //   formId: 4,
        //   startDate: typeof this.calModel9 === 'string' ? this.calModel9 : this.datePipe.transform(this.calModel9, 'dd/MM/yyyy'),
        //   endDate: typeof this.calModel10 === 'string' ? this.calModel10 : this.datePipe.transform(this.calModel10, 'dd/MM/yyyy'),
        //   roleCode: "MKTG",
        //   roleId: 28,
        //   createdBy: this.userId,
        //   createdOn: null,
        //   isActive: true,
        //   modifiedBy: this.userId,
        //   modifiedOn: _todayDate,
        //   requirementYear : this.RequirmentYear,

        // }
        const _requestMKTG_F13 = {
          formId: 13,
          startDate: typeof this.calModel33 === 'string' ? this.calModel33 : this.datePipe.transform(this.calModel33, 'dd/MM/yyyy'),
          endDate: typeof this.calModel34 === 'string' ? this.calModel34 : this.datePipe.transform(this.calModel34, 'dd/MM/yyyy'),
          roleCode: "MKTG",
          roleId: 28,
          createdBy: this.userId,
          createdOn: null,
          isActive: true,
          modifiedBy: this.userId,
          modifiedOn: _todayDate,
          requirementYear : this.RequirmentYear,

        }
        const _requestMKTG_F14 = {
          formId: 14,
          startDate: typeof this.calModel35 === 'string' ? this.calModel35 : this.datePipe.transform(this.calModel35, 'dd/MM/yyyy'),
          endDate: typeof this.calModel36 === 'string' ? this.calModel36 : this.datePipe.transform(this.calModel36, 'dd/MM/yyyy'),
          roleCode: "MKTG",
          roleId: 28,
          createdBy: this.userId,
          createdOn: null,
          isActive: true,
          modifiedBy: this.userId,
          modifiedOn: _todayDate,
          requirementYear : this.RequirmentYear,

        }
        const _requestSDHO_F6 = {
          formId: 6,
          startDate: typeof this.calModel11 === 'string' ? this.calModel11 : this.datePipe.transform(this.calModel11, 'dd/MM/yyyy'),
          endDate: typeof this.calModel12 === 'string' ? this.calModel12 : this.datePipe.transform(this.calModel12, 'dd/MM/yyyy'),
          roleCode: "SDHO",
          roleId: 52,
          createdBy: this.userId,
          createdOn: null,
          isActive: true,
          modifiedBy: this.userId,
          modifiedOn: _todayDate,
          requirementYear : this.RequirmentYear,

        }
        const _requestSDWH_F7 = {
          formId: 7,
          startDate: typeof (this.calModel13) === "string" ? this.calModel13 : this.datePipe.transform(this.calModel13, 'dd/MM/yyyy'),
          endDate: typeof (this.calModel14) === "string" ? this.calModel14 : this.datePipe.transform(this.calModel14, 'dd/MM/yyyy'),
          roleCode: "SDWH",
          roleId: 53,
          createdBy: this.userId,
          createdOn: null,
          isActive: true,
          modifiedBy: this.userId,
          modifiedOn: _todayDate,
          requirementYear : this.RequirmentYear,

        }
        this.timeline.push(_requestAMM_F9);
        this.timeline.push(_requestZMH_F9);
        this.timeline.push(_requestDMH_F9);
        this.timeline.push(_requestAMM_F10);
        this.timeline.push(_requestZMH_F10);
        this.timeline.push(_requestDMH_F10);
        this.timeline.push(_requestZMH_F11);
        this.timeline.push(_requestDMH_F11);
        this.timeline.push(_requestSBUMH_F11);
        this.timeline.push(_requestZMH_F12);
        this.timeline.push(_requestDMH_F12);
        this.timeline.push(_requestSBUMH_F12);
        this.timeline.push(_requestMKTG_F13);
        this.timeline.push(_requestMKTG_F14);
        this.timeline.push(_requestAMM_F5);
        this.timeline.push(_requestZMH_F5);
        this.timeline.push(_requestDMH_F5);
        this.timeline.push(_requestSDHO_F6);
        this.timeline.push(_requestSDWH_F7);
        this.adminRight.TimelineSettingUpdate(this.timeline).subscribe((resData: any) => {
          if (resData.status) {
            this.toastr.success('Admin timeline updated.');
            this.TimelineNotification();
          }
          else {
            this.toastr.error('Admin timeline update failed.');
          }
        })
      }
    }
    else {
      this.toastr.error('Only admin is authorized for timeline settings.');
    }
  }

  TimelineSettingView() {
    this.adminRight.TimelineSettingView(this.userId)
      .subscribe((response) => {
        if (response.status) {
          this.tsResponse = null;
          this.tsResponse = response.data;
          // this.calId1Update = this.tsResponse[0].startDate;
          //Annual requirment startdate and Enddate
          // this.calModel1 = this.tsResponse.filter(item => item.formId === 1 && item.roleId === 42)[0].startDate;
          // this.calModel2 = this.tsResponse.filter(item => item.formId === 1 && item.roleId === 42)[0].endDate;
          
          // H1 requrement startdate and enddate
          this.calModel17 = this.tsResponse.filter(item => item.formId === 9 && item.roleId === 42)[0].startDate;
          this.calModel18 = this.tsResponse.filter(item => item.formId === 9 && item.roleId === 42)[0].endDate;

          // H2 requrement startdate and enddate
          this.calModel19 = this.tsResponse.filter(item => item.formId === 10 && item.roleId === 42)[0].startDate;
          this.calModel20 = this.tsResponse.filter(item => item.formId === 10 && item.roleId === 42)[0].endDate;

          //Approval startdate and Enddate
          // this.calModel3 = this.tsResponse.filter(item => item.formId === 3 && item.roleId === 43)[0].startDate;
          // this.calModel4 = this.tsResponse.filter(item => item.formId === 3 && item.roleId === 43)[0].endDate;


          // this.calModel5 = this.tsResponse.filter(item => item.formId === 3 && item.roleId === 39)[0].startDate;;
          // this.calModel6 = this.tsResponse.filter(item => item.formId === 3 && item.roleId === 39)[0].endDate;


          // this.calModel15 = this.tsResponse.filter(item => item.formId === 3 && item.roleId === 36)[0].startDate;
          // this.calModel16 = this.tsResponse.filter(item => item.formId === 3 && item.roleId === 36)[0].endDate;

          // H1 Approval on requirement
          this.calModel21 = this.tsResponse.filter(item => item.formId === 11 && item.roleId === 43)[0].startDate;
          this.calModel22 = this.tsResponse.filter(item => item.formId === 11 && item.roleId === 43)[0].endDate;


          this.calModel23 = this.tsResponse.filter(item => item.formId === 11 && item.roleId === 39)[0].startDate;;
          this.calModel24 = this.tsResponse.filter(item => item.formId === 11 && item.roleId === 39)[0].endDate;


          this.calModel25 = this.tsResponse.filter(item => item.formId === 11 && item.roleId === 36)[0].startDate;
          this.calModel26 = this.tsResponse.filter(item => item.formId === 11 && item.roleId === 36)[0].endDate;

          // H2 Approval on requirement
          this.calModel27 = this.tsResponse.filter(item => item.formId === 12 && item.roleId === 43)[0].startDate;
          this.calModel28 = this.tsResponse.filter(item => item.formId === 12 && item.roleId === 43)[0].endDate;


          this.calModel29 = this.tsResponse.filter(item => item.formId === 12 && item.roleId === 39)[0].startDate;;
          this.calModel30 = this.tsResponse.filter(item => item.formId === 12 && item.roleId === 39)[0].endDate;


          this.calModel31 = this.tsResponse.filter(item => item.formId === 12 && item.roleId === 36)[0].startDate;
          this.calModel32 = this.tsResponse.filter(item => item.formId === 12 && item.roleId === 36)[0].endDate;

          //Cost Approval for Brand Manager
          // this.calModel9 = this.tsResponse.filter(item => item.formId === 4 && item.roleId === 28)[0].startDate;
          // this.calModel10 = this.tsResponse.filter(item => item.formId === 4 && item.roleId === 28)[0].endDate;
          
          //H1 DS cost approval
          this.calModel33 = this.tsResponse.filter(item => item.formId === 13 && item.roleId === 28)[0].startDate;
          this.calModel34 = this.tsResponse.filter(item => item.formId === 13 && item.roleId === 28)[0].endDate;

          // H2 DS cost approval
          this.calModel35 = this.tsResponse.filter(item => item.formId === 14 && item.roleId === 28)[0].startDate;
          this.calModel36 = this.tsResponse.filter(item => item.formId === 14 && item.roleId === 28)[0].endDate;

          //Demo Sample Allocation 
          this.calModel7 = this.tsResponse.filter(item => item.formId === 5 && item.roleId === 42)[0].startDate;
          this.calModel8 = this.tsResponse.filter(item => item.formId === 5 && item.roleId === 42)[0].endDate;

          //Dispatch to SD
          this.calModel11 = this.tsResponse.filter(item => item.formId === 6 && item.roleId === 52)[0].startDate;
          this.calModel12 = this.tsResponse.filter(item => item.formId === 6 && item.roleId === 52)[0].endDate;

          //dispatch to field
          this.calModel13 = this.tsResponse.filter(item => item.formId === 7 && item.roleId === 53)[0].startDate;
          this.calModel14 = this.tsResponse.filter(item => item.formId === 7 && item.roleId === 53)[0].endDate;
          this.RequirmentYear =  this.tsResponse[0].requirementYear;
        }
        else {
          this.toastr.error(response.message);
        }

      }, error => {
        this.toastr.error(error.message);
      });
  }

  TimelineNotification() {
    this.adminRight.TimelineNotification()
      .subscribe((response) => { });
  }


}
